import { render, staticRenderFns } from "./OperaHolidaysWindow.vue?vue&type=template&id=2ad98748&"
import script from "./OperaHolidaysWindow.vue?vue&type=script&lang=js&"
export * from "./OperaHolidaysWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports